export class ArrayWrapEvent
{
    static ELEMENT_CHANGED: string = "ArrayWrapEvent.ELEMENT_CHANGED";
    static ELEMENT_REMOVED: string = "ArrayWrapEvent.ELEMENT_REMOVED";
    static ELEMENT_ADDED: string = "ArrayWrapEvent.ELEMENT_ADDED";
}
